module.exports = function() {
  return new Worker(__webpack_public_path__ + "e6f783cb5de9ddba2045.worker.js");
};